import { z } from 'zod/v4';

function convertDateTimeToUTC(value: Date | string) {
  const date = new Date(value);
  date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return new Date(date.toISOString());
}

/**
 * Transforms a string to a date object and converts it to UTC if it is not already in UTC
 * @param value An unknown value. If it is a string, it will try to cast it to UTC if it is not already.
 * @returns The result of coercing the (possibly transformed) value to a date object
 */
export const coercedDate = z.preprocess((value) => {
  if (
    typeof value === 'string' &&
    !value.endsWith('Z') &&
    !value.includes('+') &&
    !(value.split('-').length >= 4)
  ) {
    return convertDateTimeToUTC(value);
  }
  return value;
}, z.coerce.date());
